"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeviceType;
(function (DeviceType) {
    DeviceType[DeviceType["Browser"] = 0] = "Browser";
    DeviceType[DeviceType["WebOS"] = 1] = "WebOS";
    DeviceType[DeviceType["Tizen"] = 2] = "Tizen";
    DeviceType[DeviceType["PS4"] = 3] = "PS4";
    DeviceType[DeviceType["PS3"] = 4] = "PS3";
    DeviceType[DeviceType["WebMaf"] = 5] = "WebMaf";
    DeviceType[DeviceType["XboxOne"] = 6] = "XboxOne";
    DeviceType[DeviceType["EETV"] = 7] = "EETV";
    DeviceType[DeviceType["YouView"] = 8] = "YouView";
    DeviceType[DeviceType["Android"] = 9] = "Android";
    DeviceType[DeviceType["NetCast"] = 10] = "NetCast";
    DeviceType[DeviceType["Videoguard"] = 11] = "Videoguard";
    DeviceType[DeviceType["Roku"] = 12] = "Roku";
    DeviceType[DeviceType["Vodafone"] = 13] = "Vodafone";
    DeviceType[DeviceType["Shaka"] = 14] = "Shaka";
    DeviceType[DeviceType["iOS"] = 15] = "iOS";
    DeviceType[DeviceType["AndroidMobile"] = 16] = "AndroidMobile";
    DeviceType[DeviceType["Chromecast"] = 17] = "Chromecast";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
